export default "__VITE_ASSET__KZ5$QYeH__"